/* import __COLOCATED_TEMPLATE__ from './iframe-composer.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { isPresent } from '@ember/utils';
let IframeComposer = (_class = class IframeComposer extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "mountingElement", _descriptor, this);
    _initializerDefineProperty(this, "iframe", _descriptor2, this);
    _defineProperty(this, "resizeObserver", void 0);
    _defineProperty(this, "autoResizeWidth", void 0);
    _defineProperty(this, "autoResizeHeight", void 0);
    _defineProperty(this, "animationFrameId", void 0);
    _defineProperty(this, "resizeObserverInitialized", false);
    _defineProperty(this, "initialIFrameHeight", 0);
    _defineProperty(this, "composer", void 0);
    _defineProperty(this, "lastAppliedHeight", void 0);
    _defineProperty(this, "lastAppliedWidth", void 0);
    this.autoResizeWidth = this.args.autoResizeWidth ?? true;
    this.autoResizeHeight = this.args.autoResizeHeight ?? true;
  }
  get isEditing() {
    return isPresent(this.args.isEditing) ? this.args.isEditing : true;
  }
  setupFrame(iframe) {
    this.iframe = iframe;
    let html = this.args.template.replace(/\{\{\s*?content\s*?\}\}/i, `<div id="put-composer-here"></div>`);
    if (iframe.contentDocument) {
      iframe.contentDocument.open();
      iframe.contentDocument.write(sanitizeHtml(html, {
        config: 'email'
      }));
      iframe.contentDocument.close();
      this.addBaseTagToHead(iframe.contentDocument);
      if (this.autoResizeWidth || this.autoResizeHeight) {
        this.setupResizeObserver(iframe);
      }
      this.mountingElement = iframe.contentDocument.getElementById('put-composer-here');
    }
  }
  addBaseTagToHead(contentDocument) {
    let head = contentDocument.head;
    let baseTag = document.createElement('base');
    baseTag.setAttribute('target', '_blank');
    head.appendChild(baseTag);
    let styleTag = document.createElement('style');
    styleTag.innerHTML = `
      body { overflow: hidden !important; }
    `;
    head.appendChild(styleTag);
  }
  setupResizeObserver(iframe) {
    if (!iframe.contentDocument) {
      return;
    }
    let documentElement = iframe.contentDocument?.documentElement;
    this.composer = documentElement.querySelector('#put-composer-here');

    //We set "initialIFrameHeight" with the same value if it exists as this method is called everytime when the template is changed.
    this.initialIFrameHeight = this.initialIFrameHeight ? this.initialIFrameHeight : documentElement.scrollHeight;
    this.resizeObserverInitialized = false;
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeObserver?.disconnect();
      // sets any table with height specified as 100% to auto to avoid infinite scrolling
      this.setTableHeightToAuto();
      if (this.autoResizeHeight) {
        let height = this.calculateIFrameHeight(documentElement);
        if (height !== this.lastAppliedHeight) {
          this.lastAppliedHeight = height;
          iframe.style.height = height;
        }
      }
      if (this.autoResizeWidth) {
        let width = `${documentElement.scrollWidth}px`;
        if (width !== this.lastAppliedWidth) {
          this.lastAppliedWidth = width;
          iframe.style.width = `${documentElement.scrollWidth}px`;
        }
      }
      this.resizeObserverInitialized = true;
      // requestAnimationFrame is required here because browsers don't currently implement the
      // ResizeObserver spec correctly: https://github.com/WICG/ResizeObserver/issues/38
      this.animationFrameId = window.requestAnimationFrame(() => {
        if (this.resizeObserver && this.composer) {
          this.resizeObserver.observe(this.composer);
        }
      });
    });
    this.resizeObserver.observe(documentElement);
  }

  /*
    When this method is run for the first time it will return the height of documentElement.scrollHeight.
    After that whenever a new block is added, it will calculate the height by adding the initialIframeHeight and composer.scrollHeight.
    This is done to fix an infinite scroll issue here: https://github.com/intercom/intercom/issues/216980.
    TLDR; The documentElement.scrollHeight always increases when body style height is set to 100%.
    So we observe the conmposer height instead and use it to calculate the iframe Height
  */
  calculateIFrameHeight(documentElement) {
    if (this.resizeObserverInitialized && this.composer) {
      return `${this.initialIFrameHeight + this.composer.scrollHeight}px`;
    } else {
      return `${documentElement.scrollHeight}px`;
    }
  }

  /*
    This method tackles the use case where table height is set to "100%" or "100% !important".
    "element?.computedStyleMap" property gives us the individual property for the specified element (inline or in style tag). However, it currently only supports on chromium browsers
    It checks whether the height is 100% and replaces it with auto if found.
    For other browsers it just checks for inline style using "element.style.height" and sets it to auto.
    This method also handles the case where html block having table is inserted from the composer.
  */
  setTableHeightToAuto() {
    let tableElements = this.iframe?.contentWindow?.document.getElementsByTagName('table');
    if (tableElements) {
      for (let element of tableElements) {
        if (element?.computedStyleMap) {
          let cssKeyWordValue = element.computedStyleMap().get('height');
          if (cssKeyWordValue && 'value' in cssKeyWordValue && cssKeyWordValue.value === 100 && 'unit' in cssKeyWordValue && cssKeyWordValue.unit === 'percent') {
            element.style.height = 'auto';
          }
        } else if (element.style.height === '100%') {
          element.style.height = 'auto';
        }
      }
    }
  }
  iframeLoaded() {
    if (this.composer && this.iframe?.contentDocument) {
      this.initialIFrameHeight = this.iframe?.contentDocument.documentElement.scrollHeight - this.composer.scrollHeight;
    }
  }
  willDestroy() {
    this.resizeObserver?.disconnect();
    if (this.animationFrameId) {
      window.cancelAnimationFrame(this.animationFrameId);
    }
    super.willDestroy();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "mountingElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "iframe", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupFrame", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupFrame"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "iframeLoaded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "iframeLoaded"), _class.prototype), _class);
export { IframeComposer as default };